import { render, staticRenderFns } from "./XgPlayer.vue?vue&type=template&id=5bd50d4a&scoped=true&"
import script from "./XgPlayer.vue?vue&type=script&lang=js&"
export * from "./XgPlayer.vue?vue&type=script&lang=js&"
import style0 from "./XgPlayer.vue?vue&type=style&index=0&id=5bd50d4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd50d4a",
  null
  
)

export default component.exports